import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import storefrontApiService, { StorefrontCommonAttributes } from 'services/api/storefront-api-service'

export interface OrdersState {
  isLoading: boolean
  orderData: OrderData | null
}

const initialState: OrdersState = {
  isLoading: false,
  orderData: null
}

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    resetOrdersState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getOrders.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.isLoading = false
        state.orderData = action.payload
      })
      .addCase(getOrders.rejected, (state) => {
        state.isLoading = false
        state.orderData = null
      })
})

export const { resetOrdersState } = ordersSlice.actions

export default ordersSlice.reducer

export const getOrders = createAsyncThunk('get-orders', async (_, { rejectWithValue }) => {
  try {
    return await storefrontApiService.getCompletedOrders()
  } catch (error) {
    return rejectWithValue(error)
  }
})

export interface OrderData {
  cart: Record<string, OrdersCartItem>
}

export interface OrdersCartItem {
  id: string
  type: string
  attributes: OrdersAttributes
  relationships: OrdersRelationships
}

export interface OrdersAttributes {
  number: string
  itemTotal: number
  total: string
  shipTotal: string
  adjustmentTotal: string
  createdAt: string
  updatedAt: string
  completedAt: string
  includedTaxTotal: string
  additionalTaxTotal: string
  displayAdditionalTaxTotal: string
  displayIncludedTaxTotal: string
  taxTotal: string
  currency: string
  state: 'canceled' | 'complete' | 'shipped'
  token: string
  email: string
  displayItemTotal: string
  displayShipTotal: string
  displayAdjustmentTotal: string
  displayTaxTotal: string
  promoTotal: string
  displayPromoTotal: string
  itemCount: number
  specialInstructions: null
  displayTotal: string
  lineItemsNames: string
  gatewaySecureModeRedirectUrl: null
  pharmacistId: number | null
  orderType:
    | null
    | 'single_items'
    | 'consultation'
    | 'package'
    | 'drugs'
    | 'phytotherapy'
    | 'sex_shop'
    | 'not_yet_categorized'
    | 'master_program'
    | 'time_program'
  trackingLink: string
  itemTotalIfPackage: number | null
}

export interface OrdersRelationships {
  lineItems: StorefrontCommonAttributes
  variants: StorefrontCommonAttributes
  promotions: StorefrontCommonAttributes
  payments: StorefrontCommonAttributes
  shipments: StorefrontCommonAttributes
  user: StorefrontCommonAttributes
  billingAddress: StorefrontCommonAttributes
  shippingAddress: StorefrontCommonAttributes
}
